import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { message, Modal, Input } from "antd";
import useAuth from "../hooks/useAuth";

const URL = process.env.REACT_APP_API_URL;

const ApproveJobDetails = () => {
  const { id } = useParams();
  const [job, setJob] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [note, setNote] = useState("");
  const [updatedBy, setUpdatedBy] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalMode, setModalMode] = useState(""); // 'Approve' or 'Reject'
  const { token } = useAuth();

  const [isJobReopened, setIsJobReopened] = useState(false);

  useEffect(() => {
    if (job && (job.status === "REQ Approved" || job.status === "Denied")) {
      setIsJobReopened(true); // Set to true only if the job is already approved or denied
    }
  }, [job]);

  useEffect(() => {
    const fetchJobDetails = async () => {
      try {
        const response = await axios.get(`${URL}/api/job/${id}`);
        setJob(response.data);
        setLoading(false);
      } catch (error) {
        setError(error.message);
        setLoading(false);
      }
    };

    fetchJobDetails();
  }, [id]);

  const sendEmailNotification = async (status, note) => {
    try {
      await axios.post(`${URL}/api/job/status`, {
        position: job.position,
        status,
        updateBy: job.updateBy,
        postedByEmail: job.postedByEmail,
        note, // Assuming this field exists in the job object
      });
      message.success("Email notification sent successfully.");
    } catch (error) {
      console.error("Failed to send email notification:", error);
      message.error("Failed to send email notification.");
    }
  };

  const updateJobStatus = async (newStatus) => {
    try {
      const updatedJob = {
        ...job,
        status: newStatus,
        approver: updatedBy || "Directors", // Use provided name or default
        history: [
          ...job.history,
          {
            updatedBy: updatedBy || "Directors", // Use provided name or default
            updatedAt: new Date(),
            note: note,
          },
        ],
      };
      await axios.put(`${URL}/api/job-posts/${id}`, updatedJob, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setJob((prevJob) => ({ ...prevJob, status: newStatus }));
      message.success(
        `Job ${
          newStatus === "REQ Approved" ? "REQ Approved" : "REQ Rejected"
        } successfully`
      );
      setIsModalVisible(false);
      sendEmailNotification(newStatus, note);
    } catch (error) {
      console.error("Update request failed:", error);
      message.error(
        `Failed to ${newStatus === "REQ Approved" ? "approve" : "reject"} job`
      );
    }
  };

  const handleModalOk = () => {
    if (!updatedBy) {
      message.error("Please provide both a note and your name.");
      return;
    }

    if (modalMode === "Denied" && !note.trim()) {
      message.error("Note is required when denying a job.");
      return;
    }
    updateJobStatus(modalMode);
  };

  const handleModalCancel = () => {
    setIsModalVisible(false);
    setNote("");
    setUpdatedBy("");
  };

  const showApproveModal = () => {
    setModalMode("REQ Approved");
    setIsModalVisible(true);
  };

  const showRejectModal = () => {
    setModalMode("Denied");
    setIsModalVisible(true);
  };

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error}</p>;
  if (!job) return <p>Job not found</p>;

  const statusMessageStyle = {
    color:
      job.status === "Denied"
        ? "red"
        : job.status === "REQ Approved"
        ? "green"
        : "inherit",
    fontWeight: "bold",
    background: "#fff",
  };



  return (
    <div className="bg">
      <div className="job-details">
      {isJobReopened && (
  <p style={statusMessageStyle}>
    The current Job is already {job.status} on{" "}
    {new Date(job.postedAt).toLocaleString()}
  </p>
)}
        {/* {(job.status === "REQ Approved" || job.status === "Denied") && (
          <p style={statusMessageStyle}>
            The current Job is already {job.status} on{" "}
            {new Date(job.postedAt).toLocaleString()}
          </p>
        )} */}
        <h2>{job.position}</h2>
        <br />
        <br />
        <p>
          <strong>Department:</strong> {job.department}
        </p>
        <p>
          <strong>Description:</strong> {job.description}
        </p>
        <p>
          <strong>Job Location:</strong> {job.jobLocation}
        </p>
        <p>
          <strong>Vacancies:</strong> {job.vacancies}
        </p>
        <p>
          <strong>Experience:</strong> {job.experience}
        </p>
        <p>
          <strong>Responsibilities:</strong> {job.responsibilities}
        </p>
        <p>
          <strong>Primary Skills:</strong> {job.primarySkills.join(", ")}
        </p>
        {job.secondarySkills && (
          <p>
            <strong>Secondary Skills:</strong> {job.secondarySkills.join(", ")}
          </p>
        )}
        <p>
          <strong>Status:</strong> {job.status}
        </p>
        <p>
          <strong>Posted By:</strong> {job.postedBy} on{" "}
          {new Date(job.postedAt).toLocaleString()}
        </p>

        {(job.status !== "REQ Approved" && job.status !== "Denied") && (
          <div className="button-container">
            <button onClick={showApproveModal}>Approve</button>
            <button onClick={showRejectModal}>Reject</button>
          </div>
        )}
      </div>

      <Modal
        title={modalMode === "REQ Approved" ? "Approve Job" : "Reject Job"}
        open={isModalVisible}
        onOk={handleModalOk}
        onCancel={handleModalCancel}
        okText={modalMode === "REQ Approved" ? "Approve" : "Reject"}
        cancelText="Cancel"
      >
        <Input.TextArea
          rows={4}
          placeholder="Please Enter note which will be sent to the Operations team (if any)"
          value={note}
          onChange={(e) => setNote(e.target.value)}
        />
        <Input
          placeholder="Enter your name"
          value={updatedBy}
          onChange={(e) => setUpdatedBy(e.target.value)}
          style={{ marginTop: '10px' }}
        />
      </Modal>
    </div>
  );
};

export default ApproveJobDetails;
